// Date and time of a Modeling Process feedback message, e.g. "Sep 28, 2:02 PM"
export function formatFeedbackTime (timestamp) {
  if (!timestamp || !timestamp.toDate) {
    return ''
  }
  return timestamp.toDate().toLocaleString('en-US', { month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit' })
}
